<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-CloseWide`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.59968 5.18572C6.20916 4.79519 5.576 4.79519 5.18547 5.18572C4.79495 5.57624 4.79495 6.2094 5.18547 6.59993L8.58558 10L5.18547 13.4001C4.79495 13.7907 4.79495 14.4238 5.18547 14.8144C5.576 15.2049 6.20916 15.2049 6.59968 14.8144L9.99979 11.4143L13.3999 14.8144C13.7904 15.2049 14.4236 15.2049 14.8141 14.8144C15.2046 14.4238 15.2046 13.7907 14.8141 13.4001L11.414 10L14.8141 6.59993C15.2046 6.2094 15.2046 5.57624 14.8141 5.18572C14.4236 4.79519 13.7904 4.79519 13.3999 5.18572L9.99979 8.58582L6.59968 5.18572Z"/></svg>
</template>
<script>

export default {
  name: 'IconCloseWide',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
